import { TreeSelect } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const TreeDiv = styled.div`
  .ant-select-tree .ant-select-tree-treenode {
    padding: 0 0 15px 0;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.GREY_T_20};
    text-transform: capitalize;
  }
  .ant-select-tree-indent {
    display: ${props => (props.removeIndent ? 'none' : 'block')};
  }
`
export const TreeSelectLocal = styled(TreeSelect)`
  width: ${props => (props?.width ? props?.width : '100%')};
  margin-top: 10px;
  .ant-select-selection-placeholder {
    font-size: ${props =>
      props.placeholderSize ? props.placeholderSize : 'inherit'};
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: ${props => (props?.height ? props?.height : '40px')};
    min-height: 40px;
    width: 100%;
    background: ${props =>
      props.white ? '#ffffff' : COLORS.PRIMARY_GREY_T_98};
    border: ${props =>
      props.shadowBox ? 'border: 1px solid #D6DBF7' : ' 1px solid #e6e7ea'};
    border-radius: 10px;
    font-size: 16px;
    line-height: 24px;
      font-weight: ${props =>
        props.placeholderStyle ? '500' : '600'};
    }
    &.ant-select-selection-placeholder {
      color: #B1B1B1;
      font-size: 16px;
      font-weight: ${props =>
        props.placeholderStyle ? '500' : '600'};
          line-height: 24px !important;
    }
    }
    box-shadow: ${props =>
      props.shadowBox ? '0px 2px 6px 0px #7b61ff26' : 'unset'};
  }
`
